import { TApplicationState } from '../../types/redux';

export const selectSubdomain = (state: TApplicationState) => {
  return state.common.subdomain;
};
